import api from "axios";

export const releasePayment = async (id_avaliacao) => {
  return api
    .post(`/purchasers/releasePayment/${id_avaliacao}`)
    .then((response) => response.data)
    .catch((error) => error);
};
